/**
 * Formats a number with thousand separators
 */
export function formatNumber(num: number): string {
  return new Intl.NumberFormat('de-DE').format(Math.round(num))
}

/**
 * Formats a decimal number with specified decimal places
 */
export function formatDecimal(num: number, decimalPlaces: number = 2): string {
  return new Intl.NumberFormat('de-DE', {
    minimumFractionDigits: decimalPlaces,
    maximumFractionDigits: decimalPlaces,
  }).format(num)
}
